import axios from "axios";
// import cors from "cors";

const instance = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}`,
    withCredentials: true
});

export default instance;